import React from 'react'
import {Table, Typography} from 'antd';
import dayjs from 'dayjs';
import type {ColumnsType} from 'antd/es/table';
import {DeliveryEnum, GetOrderWarehouseResponse, SaleOrderStatusEnum} from 'generated/api'
import OrderConfirmationModal from './OrderConfirmationModal';
import Button from 'components/button/Button';
import DataCard from 'components/card/DataCard';

interface DataType {
  key: string;
  name: string;
  quantity: number;
}

interface IProps {
  order: GetOrderWarehouseResponse,
  isModalOpenUpdateOrderStatus: boolean,
  isLoadingUpdateOrderStatus: boolean,
  setModalOpenUpdateOrderStatus: (value: boolean) => void
  updateOrderStatus: () => void
}

const statusText = (status: SaleOrderStatusEnum) => {
  const text: Record<string, string> = {
    [SaleOrderStatusEnum.ReadyToPickUp]: 'pesanan siap', 'default': status,
  }
  return text[status] || text['default']
}

const statusBgColor = (status: SaleOrderStatusEnum) => {
  const bg: Record<string, string> = {
    [SaleOrderStatusEnum.ReadyToPickUp]: 'bg-[#72BA24]',
    'default': 'bg-[#C5C5C5]',
  }
  return bg[status] || bg['default']
}

const deliveryText = (method: DeliveryEnum) => {
  const text: Record<string, string> = {
    [DeliveryEnum.Pickup]: 'Ambil Sendiri',
    [DeliveryEnum.Delivery]: 'Pengiriman',
    'default': method
  }
  return text[method] || text['default']
}

const OrderConfirmationDetail = (props: IProps) => {
  const {order} = props
  const columns: ColumnsType<DataType> = [
    {title: 'Info Produk', dataIndex: 'name', key: 'name'},
    {title: 'Jumlah', dataIndex: 'quantity', key: 'quantity'},
  ];

  const data: DataType[] = props.order?.productItems?.
    map((itemProduct, indexProduct) => ({
      key: indexProduct.toString(),
      name: itemProduct.name,
      quantity: itemProduct.quantity,
    }));

  return (
    <div className="w-full">
      <OrderConfirmationModal
        isOpen={props.isModalOpenUpdateOrderStatus}
        setModal={props.setModalOpenUpdateOrderStatus}
        updateOrderStatus={props.updateOrderStatus}
        isLoadingUpdateOrderStatus={props.isLoadingUpdateOrderStatus}
      />
      <div className="block md:flex md:justify-between mb-4">
        <div>
          <Typography.Title className='mt-0 text-lg font-semibold'>Nomor Invoice
            <span className='text-xl text-[#E59601] font-bold ml-3'>#{order.invoiceNo}</span>
          </Typography.Title>
          <div className="mt-2">
            <span
              className={`${statusBgColor(order.orderStatus)} py-2 inline-block px-2 text-xs text-white font-bold rounded-lg uppercase`}>
              {statusText(order.orderStatus)}
            </span>
          </div>
        </div>
        <div>
          <Button
            data-testid="btn_update_order_status"
            className="w-full uppercase hover:cursor-pointer py-4 px-6 rounded-xl"
            onClick={() => props.setModalOpenUpdateOrderStatus(true)}
            label="sudah diambil" variant="solid-primary"
          />
        </div>
      </div>
      <div className="flex flex-col md:flex-row gap-2 flex-wrap">
        <DataCard
          title="Pesanan"
          list={[
            {label: 'Nomor Pesanan', value: order.orderNo},
            {label: 'Waktu Pemesanan', value: dayjs(order.orderDateAtUtc0).format('DD MMMM YYYY HH:mm:ss')},
            {label: 'Metode Pengiriman', value: deliveryText(order.deliveryMethod)}
          ]}
        />
        <DataCard
          title="Pembeli"
          list={[
            {label: 'Nama', value: order.customerName},
            {label: 'Nomor Telepon', value: order.customerPhoneNo}
          ]}
        />
        <DataCard
          title="Penjemput"
          list={[
            {label: 'Nama', value: order.recipientName},
            {label: 'Nomor Telepon', value: order.recipientPhoneNo},
            {label: 'Plat Nomor Kendaraan', value: order.vehicleLicenseNo}
          ]}
        />
      </div>
      <Typography>
        <Typography.Title level={5} className="mt-6 mb-2">
          Daftar Pesanan
        </Typography.Title>
      </Typography>
      <Table className="table-secondary table-secondary--admin" dataSource={data} columns={columns} pagination={false}/>
    </div>
  )
}

export default OrderConfirmationDetail
